import React, { FC } from 'react'
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles'
import { Button } from '@material-ui/core'
import { TranslatedTextType } from '@dg-shared/hooks/useTranslate'

interface ButtonNext {
  buttonText: TranslatedTextType
  customClassName?: string
  disabled?: boolean
  outlined?: boolean
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  handleClick?(): void
  testId?: string
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonNext: (outlined) => ({
      fontSize: '1rem',
      backgroundColor: outlined ? theme.palette.secondary.contrastText : theme.palette.primary.main,
      color: outlined ? theme.palette.primary.main : theme.palette.secondary.contrastText,
      border: outlined ? `1px solid ${theme.palette.primary.main}` : 'none',
      boxShadow: outlined && 'none',
      maxWidth: '345px',
      margin: '0 auto',
    }),
  })
)

const FSMBtnNext: FC<ButtonNext> = ({
  buttonText,
  customClassName,
  disabled = false,
  outlined = false,
  startIcon,
  endIcon,
  handleClick,
  testId = 'FSMBtnNext',
}) => {
  const classes = useStyles(outlined)

  return (
    <Button
      data-testid={testId}
      disabled={disabled}
      onClick={handleClick}
      variant='contained'
      size='medium'
      className={`${classes.buttonNext} ${customClassName}`}
      fullWidth
      startIcon={startIcon}
      endIcon={endIcon}
    >
      {buttonText}
    </Button>
  )
}

export default FSMBtnNext
